import { styled } from '@volkswagen-onehub/components-core';

export const StyledTable = styled.table`
	border-collapse: collapse;
	width: 100%;
	font-size: 14px;
	padding: 8px;
	color: #001e50;

	thead {
		background: #1a56a5;
		font-weight: 600;
	}

	tr:nth-child(odd) {
		background: #f4f4f4;
	}

	td,
	th {
		border: 1px solid #ccc;
		padding: 0.75rem;
		text-align: left;
		vertical-align: top;
		overflow-wrap: anywhere;
	}

	td .variant-key {
		display: inline-block;
		max-width: 14rem;
		word-break: break-all;
		font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
		font-size: 12px;
		line-height: 1.4;
	}

	thead th button {
		background: none;
		border: none;
		color: inherit;
		font: inherit;
		cursor: pointer;
		padding: 0;
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	.cell-list {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.cell-list-item {
		background: #fff;
		padding: 4px 6px;
		border-radius: 4px;
		border: 1px solid #ddd;
	}
`;
